module.exports = __webpack_public_path__ + "img/session-gear.a2c83053.svg";